import styled from 'styled-components';
import { Button, Label } from '../../../components/uielements';
import { key, palette } from 'styled-theme';

const mobileBreakpoint = key('breakpoints.mobile', '480px');
const tabletBreakpoint = key('breakpoints.tablet', '820px');

const gap = {
  medium: key('sizes.gap.normal', '16px'),
  big: key('sizes.gap.medium', '24px'),
};

export const Main = styled.main`
  width: 100vw;
  background-color: ${palette('background', 0)};
  padding-top: 120px;
  position: relative;
  overflow-y: auto;
  max-height: 100vh;
  overflow-x: hidden;
`;

export const Heading = styled(Label).attrs({ size: 'header2', color: 'black', weight: 'bold' })`
  text-transform: uppercase;
  margin: auto;
  display: grid;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  > span {
    font-size: 15px;
    font-weight: 400;
    color: #6c757d;
    margin-left: 5px;
    text-transform: none;
  }
  @media (max-width: ${mobileBreakpoint}) {
    grid-template-columns: 1fr;
    width: 100%;
    gap: ${gap.medium};
    padding: 0 ${gap.medium};
  }
`;

export const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 150px;
  background-image: url(${(props) => props.bg});
  transition: background-image 0.5s ease-in-out;
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: flex-start;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding-top: 10px;
  padding-left: 120px;
`;

export const Logo = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: white;
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 65%;
  max-width: 900px;
  margin: auto;

  @media (max-width: ${tabletBreakpoint}) {
    width: 100%;
    gap: ${gap.medium};
    padding: 0 ${gap.medium};
  }

  @media (max-width: ${mobileBreakpoint}) {
    grid-template-columns: 1fr;
    width: 100%;
    gap: ${gap.medium};
    padding: 0 ${gap.medium};
  }
`;

export const Card = styled.div`
  background-color: #fafafa;
  border: 1px solid #d7d7e2;
  padding: 16px;
  border-radius: 8px;
  display: grid;
  gap: 15px;
`;

export const Title = styled.h3`
  font-family: 'Inter';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  color: #190f32;
  line-height: 26px;
  display: flex;
  justify-content: space-between;
`;

export const FileName = styled.p`
  font-size: 14px;
  color: #190f32;
  margin-bottom: 8px;
  font-family: 'Inter';
`;

export const UploadButton = styled.label`
  font-size: 14px;
  color: #190f32;
  cursor: pointer;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  text-decoration: underline;
  width: fit-content;
  text-underline-offset: 4px;
  &:hover {
    color: #0000ff;
  }
`;

export const PurchaseButton = styled.label`
  font-size: 14px;
  color: #190f32;
  cursor: pointer;
  font-family: 'Inter';
  font-style: normal;
  width: fit-content;
  font-weight: 400;
  text-decoration: underline;
  text-underline-offset: 3px;
  &:hover {
    color: #0000ff;
  }
`;

export const ViewButton = styled.label`
  font-size: 14px;
  color: #0000ff;
  cursor: pointer;
  font-family: 'Inter';
  font-style: normal;
  width: fit-content;
  font-weight: 400;
  text-decoration: underline;
  text-underline-offset: 3px;
`;

export const Input = styled.input`
  display: none;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 50px 0px 40px 0px;

  @media (max-width: ${mobileBreakpoint}) {
    gap: ${gap.medium};
    padding: 0 ${gap.medium};
    margin: ${gap.big} 0;

    & > button {
      width: 100%;
      justify-content: center;
    }
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: #e0e0e0;
  border-radius: 4px;
  margin-top: 10px;
  overflow: hidden;
`;

export const Progress = styled.div`
  height: 100%;
  width: 0%;
  background-color: #2b6cb0;
  transition: width 0.4s ease-in-out;
`;

export const StatusMessage = styled.p`
  margin-top: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ status }) => (status === 'error' ? '#e53e3e' : '#2f855a')};
`;

export const RivewAndLoadgeButton = styled(Button)`
  padding: 0px 40px;
  margin-bottom: 40px;

  @media (max-width: ${mobileBreakpoint}) {
    padding: 12px ${gap.medium};
    margin-bottom: 0;
    max-width: unset;
    min-width: unset;
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  padding: 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ef4444;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => (props.disabled ? 'transparent' : '#fee2e2')};
  }
`;
